module.exports = __webpack_public_path__ + "static/media/Slice4.8c474faf.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_174/img/Slice4.png
// module id = 1607
// module chunks = 0